import { PercentageOutlined } from "@ant-design/icons";
import { Card, Flex, Grid, Input, Segmented, Space, Typography } from "antd";
import deliveryServiceTypes from "../../../constants/deliveryServiceTypes";

const { useBreakpoint } = Grid;
const { Text } = Typography;

export default function DeliverySettingsPriceSettings({
  deliveryService,
  defaultSetting,
  settings,
  setSettings,
  isSettingMatch
}) {
  const screens = useBreakpoint();

  return (
    <Card
      variant="borderless"
      style={{
        height: screens.md ? "220px" : screens.xs ? "380px" : "340px",
        width: "100%",
        borderRadius:
          (defaultSetting.enabled === false && isSettingMatch === true)
            || (settings.enabled === true && isSettingMatch === false)
            ? "15px 15px 0 0"
            : "15px",
        border: 0,
        alignContent: "end"
      }}
    >
      <Flex
        justify={screens.md ? "space-between" : undefined}
        align={screens.md ? "end" : "start"}
        vertical={screens.md ? false : true}
        gap={screens.md ? undefined : "large"}
      >
        <Space size="middle">
          <Space.Compact direction="vertical">
            <Text
              strong
              disabled={defaultSetting.enabled === false && isSettingMatch === true ? true : false}
              style={{ fontSize: "15px", margin: 0, lineHeight: 1 }}
            >
              Round Price
            </Text>
            <Text
              type="secondary"
              disabled={defaultSetting.enabled === false && isSettingMatch === true ? true : false}
              style={{ fontSize: "15px", margin: 0, lineHeight: 1 }}
            >
              Round price to $x.99
            </Text>
          </Space.Compact>
          <Segmented
            disabled={defaultSetting.enabled === false && isSettingMatch === true ? true : false}
            value={settings.roundPrice ? "Yes" : "No"}
            options={["Yes", "No"].map(value => ({
              label: <div style={{ width: "50px" }}>{value}</div>,
              value,
            }))}
            onChange={value =>
              setSettings((prev) => ({
                ...prev,
                roundPrice: value === "Yes" ? true : false
              }))
            }
          />
        </Space>
        <Space size="middle">
          <Space.Compact direction="vertical">
            <Text
              strong
              disabled={defaultSetting.enabled === false && isSettingMatch === true ? true : false}
              style={{ fontSize: "15px", margin: 0, lineHeight: 1 }}
            >
              Price Increase (% to Charge)
            </Text>
            <Text
              type="secondary"
              disabled={defaultSetting.enabled === false && isSettingMatch === true ? true : false}
              style={{ fontSize: "15px", margin: 0, lineHeight: 1 }}
            >
              {`${deliveryServiceTypes[deliveryService].capitalFirst}  standard commision is 17%`}
            </Text>
          </Space.Compact>
          <Input
            value={settings.percentToCharge}
            disabled={defaultSetting.enabled === false && isSettingMatch === true ? true : false}
            suffix={<PercentageOutlined style={{ color: "rgba(0,0,0,.45)" }} />}
            style={{ width: "130px" }}
            onChange={(val) =>
              setSettings((prev) => ({
                ...prev,
                percentToCharge: val.target.value,
              }))
            }
          />
        </Space>
      </Flex>
    </Card>
  );
};